import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class InterviewInvite extends DomainObject {
  @observable startDate;
  @observable endDate;
  @observable interviewSchedule;
  @observable candidate;
}

export default InterviewInvite;
